import "./comment-composer.scss";

// Rewrites bare `@Name` runs (for known workspace members) into styled Markdown mention links
// (`[@Name](#mention)`) so the rendered comment highlights them. Pure text transform — the
// live @-mention autocomplete lives in comment-editor.tsx; this is the read-side counterpart.
export function highlightMentions(text: string, candidates: string[]): string {
  if (candidates.length === 0) return text;
  // Single pass with a combined alternation (longest candidate first) so a shorter name can't
  // re-match inside an already-rewritten longer mention.
  const sorted: string[] = [...candidates].sort((a: string, b: string) => b.length - a.length);
  const alternation: string = sorted.map((name: string) => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
  const regex: RegExp = new RegExp(`@(${alternation})\\b`, "g");
  return text.replace(regex, (_match: string, name: string) => `[@${name}](#mention)`);
}
